import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const MobileAppForm2290 = () => {
  const [open, setOpen] = useState(false);

  // const [isvideoPopupAuto, setvideoPopupAuto] = useState(false);
  const [isvideoPopupSteps, setvideoPopupSteps] = useState(false);

  // const openPopupSteps = () => {
  //   setvideoPopupSteps(true);
  // };

  const [visible, setVisible] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false, // change to true if you only want to animate once
  });

  useEffect(() => {
    setVisible(inView);
  }, [inView]);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: 'Need to claim a refund using Form 8849?',
  //   SubHeading:
  //     'File it hassle-free and get your money back. E-file now for a quick refund.',
  //   CtaText: 'E-file Form 8849 Now',
  //   CtaSubHeading: `Get your refund now`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290sticky`,
  //   isActive: true,
  // };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="File Form 2290 with TaxZerone Mobile App | IRS Authorized"
          description="Download the FREE TaxZerone mobile app to e-file Form 2290 in minutes. Simple, secure, and IRS-approved with instant access to your Schedule 1."
          keywords=""
          canonical="excise-tax/form-2290-mobile-app/"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
          ogShareImg="assets/images/excise-share-img.png"
        />
      }
    >
      <ExciseSubMenu />

      <VideoPopup
        isvideoPopup={isvideoPopupSteps}
        setvideoPopup={setvideoPopupSteps}
        src="https://www.youtube.com/embed/QnUmGYD2yLw?autoplay=1&rel=0"
      />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container
        component="section"
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #3d405b, #0d2b2f)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                color: '#d7d7d7ff',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 Deadline Has Passed!</strong> File{' '}
              <b style={{ color: '#fff', fontWeight: 600 }}>
                Form 2290 (2026–27) Now{' '}
              </b>
              to Avoid Further{' '}
              <b style={{ color: '#fff', fontWeight: 600 }}>Penalties.</b>
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time Left Until the Deadline:
              </Typography> */}
              {/* <Countdown date={lastDayTaxSeason} renderer={renderer} /> */}
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=2290app`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#0a7581',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container component="section" maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File{' '}
                <span className="highlight-container">
                  <span className="highlight">IRS Form 2290 Online</span>
                </span>{' '}
                with the TaxZerone Mobile App
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 6,
                }}
              >
                With the TaxZerone Mobile App, truckers, fleet owners, and
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                owner-operators can e-file Form 2290 directly from their phone.
                IRS-approved, secure, and designed for busy drivers on the go.
              </Typography>
              <Box
                sx={{
                  my: 1,
                  mb: 0,
                  '& img': {
                    width: { xs: 120, sm: 180 },
                    height: { xs: 37, sm: 55 },
                  },
                }}
              >
                <Link
                  href="https://play.google.com/store/apps/details?id=com.taxzerone.excisetaxes"
                  target="_blank"
                  sx={{
                    mr: { xs: 1, sm: 1 },
                    my: { xs: 0, sm: 0 },
                    display: 'inline-block',
                  }}
                >
                  <Tooltip title="Available on the Google Play" arrow>
                    <picture>
                      <source srcSet="/assets/images/play-store-img.webp" />
                      <source srcSet="/assets/images/play-store-img.png" />
                      <img
                        src="/assets/images/play-store-img.png"
                        alt="Available on the Google Play"
                        width={180}
                        height={55}
                      />
                    </picture>
                  </Tooltip>
                </Link>
                <Link
                  href="https://apps.apple.com/us/app/e-file-form-2290-pay-hvut/id6450998674"
                  target="_blank"
                  sx={{
                    ml: { xs: 1, sm: 1 },
                    my: { xs: 0, sm: 0 },
                    display: 'inline-block',
                  }}
                >
                  <Tooltip title="Download on the App Store" arrow>
                    <picture>
                      <source srcSet="/assets/images/app-store-img.webp" />
                      <source srcSet="/assets/images/app-store-img.png" />
                      <img
                        src="/assets/images/app-store-img.png"
                        alt="Download on the App Store"
                        width={180}
                        height={55}
                      />
                    </picture>
                  </Tooltip>
                </Link>
              </Box>
              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    sx={{
                      '&.btn-primary.medium': {
                        fontSize: {
                          xs: '15px !important',
                          sm: '20px  !important',
                          md: '17px !important',
                          lg: '20px !important',
                        },
                      },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    Start Filing Now
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Just{' '}
                    <span style={{ color: '#1da94a', fontWeight: 600 }}>
                      $19.99 per
                    </span>{' '}
                    return
                  </Typography>
                </Box>
                <Hidden mdDown>
                  <Box
                    sx={{
                      mb: { xs: '16px !important', sm: '22px !important' },
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/irs-authorized.webp"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <source
                        srcSet="/assets/images/irs-authorized.png"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <img
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                    </picture>
                  </Box>
                </Hidden>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              //  className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/app2290-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/app2290-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/app2290-landing-img.png"
                  alt="E-File IRS Form 2290 Online with the TaxZerone Mobile App"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              //  className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/app2290-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/app2290-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/app2290-landing-img-sm.png"
                  alt="E-File IRS Form 2290 Online with the TaxZerone Mobile App"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Box
        component="section"
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Trusted by 50,000+ Truckers Nationwide
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} p={2}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={50000}
                        duration={2}
                        suffix="+"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'Forms Filed '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Forms Filed
                </strong>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'grid',
                    gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    placeContent: 'start',
                    margin: 'auto',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <Box component="div" ref={ref}>
                    {visible ? (
                      <strong>
                        <CountUp
                          end={4.99}
                          duration={1}
                          decimal="."
                          decimals={1}
                          // suffix="⭐"
                          style={{
                            fontWeight: 600,
                            fontSize: 44,
                          }}
                        />
                      </strong>
                    ) : (
                      'Customer Rating '
                    )}
                  </Box>
                  <img
                    src="/assets/images/star-icon.svg"
                    width={30}
                    height={28}
                    alt="star-1"
                    style={{ top: 18, position: 'relative' }}
                  />
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Customer Rating
                </strong>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={100}
                        duration={2}
                        suffix="%"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'IRS Acceptance  '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#6d6d6d',
                  }}
                >
                  IRS Acceptance
                </strong>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={3}
                        duration={1}
                        suffix="Min"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'Average Filing time '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#6d6d6d',
                  }}
                >
                  Average Filing time
                </strong>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        component="section"
        sx={{
          backgroundColor: '#fff',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: 0,
        }}
      >
        <Container sx={{ maxWidth: '1200px !important' }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                How to E-File IRS Form 2290 Using the TaxZerone Mobile App
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                  fontWeight: 400,
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                TaxZerone makes filing your 2290 return anytime, anywhere-fast,
                simple, and secure.
              </Typography>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={1}
                alignItems="center"
              >
                <Box
                  sx={{
                    '& img': {
                      width: { xs: '100%', sm: 500 },
                      height: { xs: '100%', sm: 500 },
                    },
                  }}
                >
                  <picture>
                    <source
                      srcSet="/assets/images/2290app-steps-img.webp"
                      className="img-responsive-banner"
                      width={500}
                      height={500}
                    />
                    <source
                      srcSet="/assets/images/2290app-steps-img.png"
                      className="img-responsive-banner"
                      width={500}
                      height={500}
                    />
                    <img
                      src="/assets/images/2290app-steps-img.png"
                      alt="How to E-File IRS Form 2290 Using the TaxZerone Mobile App"
                      width={500}
                      height={500}
                    />
                  </picture>
                </Box>
                <Box sx={{ textAlign: 'left', width: '100%', maxWidth: 450 }}>
                  <Box
                    component="ul"
                    sx={{
                      textAlign: 'left',
                      listStyleType: 'none',
                      p: 0,
                      '& li': {
                        mb: 3.5,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                      },
                    }}
                  >
                    <li>
                      <CheckCircleOutlineIcon
                        sx={{ color: '#1da94a', mr: 1, mb: -0.7 }}
                      />
                      <Box>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Download & Sign In
                        </span>
                        <br />
                        Get the free TaxZerone 2290 mobile app from the
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          App Store
                        </span> or{' '}
                        <span style={{ fontWeight: 600 }}>Google Play</span>.
                        Create an account or log in — returning users get
                        auto-filled vehicle details.
                      </Box>
                    </li>
                    <li>
                      <CheckCircleOutlineIcon
                        sx={{ color: '#1da94a', mr: 1, mb: -0.7 }}
                      />
                      <Box>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Enter & Review Details
                        </span>
                        <br />
                        Add your business info, first-use month, VIN, and
                        taxable weight. Review for accuracy.
                      </Box>
                    </li>
                    <li>
                      <CheckCircleOutlineIcon
                        sx={{ color: '#1da94a', mr: 1, mb: -0.7 }}
                      />
                      <Box>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Pay & Get Schedule 1
                        </span>
                        <br />
                        Select your IRS payment method, e-file your 2290 form, &
                        instantly receive your IRS-stamped Schedule 1 in the app
                        and via email.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Truckers Choose TaxZerone
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS Approved"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Approved
                </Typography>
                <Typography variant="body1">
                  A fully authorized IRS e-file provider. File with confidence
                  knowing that your returns are secure, accurate, and submitted
                  directly to the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/mobile-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/mobile-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/mobile-icon.png"
                      alt="Mobile-First Design"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Mobile-First Design
                </Typography>
                <Typography variant="body1">
                  File your Form 2290 anywhere, anytime directly from your
                  smartphone. You do not need computers or complicated software.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fast-filing-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fast-filing-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fast-filing-icon.png"
                      alt="Lightning Fast Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Lightning Fast Filing
                </Typography>
                <Typography variant="body1">
                  Complete your 2290 filing in less than 5 minutes. Our
                  streamlined filing process gets you back on the road quicker.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant Schedule 1"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Schedule 1
                </Typography>
                <Typography variant="body1">
                  Instantly get your stamped Schedule 1 copy right after you
                  file. You can print or save your record digitally.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/hidden-cost-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/hidden-cost-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/hidden-cost-icon.png"
                      alt="No Hidden Fees"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  No Hidden Fees
                </Typography>
                <Typography variant="body1">
                  Transparent pricing with no surprise charges. Pay only what
                  you see - no processing fees or hidden costs.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Support
                </Typography>
                <Typography variant="body1">
                  Our friendly support team will always give you a quick
                  response to your questions and walk you through each step of
                  e-filing.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
          mb: { xs: 4, sm: 8, md: 10 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Simple, Transparent Pricing
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }} textAlign="center">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  minHeight: '100%',
                  borderRadius: 3,
                  backgroundColor: '#f0f2f9',
                  alignSelf: 'stretch',
                  justifyContent: 'space-between',
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  border: '3px solid #626262',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Single Vehicle"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Single Vehicle
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong
                    style={{
                      fontWeight: 700,
                      fontSize: '45px',
                      color: '#1da94a',
                    }}
                  >
                    {' '}
                    $19.99
                  </strong>
                  /return{' '}
                </Typography>
                <Typography variant="body1">
                  Perfect for
                  <br /> owner-operators{' '}
                </Typography>
                <Box
                  sx={{
                    mt: 1,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    E-file Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }} textAlign="center">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  minHeight: '100%',
                  borderRadius: 3,
                  backgroundColor: '#f0f2f9',
                  alignSelf: 'stretch',
                  justifyContent: 'space-between',
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  border: '3px solid #626262',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fleet-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fleet-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fleet-icon.png"
                      alt="3 to 5 Vehicles"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      mb: 1,
                      mt: 2,
                    }}
                  >
                    3 to 5 Vehicles
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    <strong
                      style={{
                        fontWeight: 700,
                        fontSize: '45px',
                        color: '#1da94a',
                      }}
                    >
                      {' '}
                      $29.99
                    </strong>
                    /return{' '}
                  </Typography>
                  <Typography variant="body1">
                    Ideal for small fleets
                  </Typography>
                </Box>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    E-file Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }} textAlign="center">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  minHeight: '100%',
                  borderRadius: 3,
                  backgroundColor: '#f0f2f9',
                  alignSelf: 'stretch',
                  justifyContent: 'space-between',
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  border: '3px solid #626262',
                }}
              >
                {' '}
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fleet-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fleet-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fleet-icon.png"
                      alt="3 to 5 Vehicles"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      mb: 1,
                      mt: 2,
                    }}
                  >
                    6 to 10 Vehicles
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    <strong
                      style={{
                        fontWeight: 700,
                        fontSize: '45px',
                        color: '#1da94a',
                      }}
                    >
                      {' '}
                      $39.99
                    </strong>
                    /return{' '}
                  </Typography>
                  <Typography variant="body1">
                    Perfect for growing fleets
                  </Typography>
                </Box>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    E-file Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }} textAlign="center">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  minHeight: '100%',
                  borderRadius: 3,
                  alignSelf: 'stretch',
                  justifyContent: 'space-between',
                  display: 'grid',
                  gridTemplateColumns: '1fr',

                  backgroundColor: '#f0f2f9',
                  border: '3px solid #626262',
                }}
              >
                {' '}
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fleet-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fleet-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fleet-icon.png"
                      alt="3 to 5 Vehicles"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    mb: 1,
                    mt: 2,
                  }}
                >
                  More than 10 Vehicles
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Find the right plan for your fleet
                </Typography>
                <Box
                  sx={{
                    mt: { md: 3, sm: 10, xs: 3 },
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      backgroundColor: '#1da94a',
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href="/pricing/#excise"
                  >
                    View Full Pricing
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            flexDirection={{ xs: 'column-reverse', md: 'row' }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 3 }, mt: { xs: -3, md: 3 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Download the FREE TaxZerone 2290 Mobile App — File Anywhere,
                  Anytime
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                  }}
                >
                  Available on iPhone, iPad, and Android devices.
                </Typography>

                <Box
                  sx={{
                    mt: 2,
                    mb: 1,
                    '& img': {
                      width: { xs: 120, sm: 180 },
                      height: { xs: 37, sm: 55 },
                    },
                  }}
                >
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.taxzerone.excisetaxes"
                    target="_blank"
                    sx={{
                      mr: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Available on the Google Play" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/play-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/play-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/play-store-img.png"
                          alt="Available on the Google Play"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <Link
                    href="https://apps.apple.com/us/app/e-file-form-2290-pay-hvut/id6450998674"
                    target="_blank"
                    sx={{
                      ml: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Download on the App Store" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/app-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/app-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/app-store-img.png"
                          alt="Download on the App Store"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ mt: 0, mb: { xs: 2, md: 2 } }}
                >
                  Take the high-speed express lane for hassle-free 2290 filing!
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/2290-mobile-app-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/2290-mobile-app-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/2290-mobile-app-img.png"
                    alt="E-File Form 2290 on the go…"
                    className="img-responsive"
                    loading="lazy"
                    width={657}
                    height={770}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Start Filing Today with TaxZerone
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          IRS-Authorized Form 2290 E-Filing, Easy and Reliable.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 0 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
          >
            E-file Form 2290 Now
          </Button>
          <Typography
            variant="body2"
            sx={{ mt: 1, mb: { xs: 0, md: 0 } }}
            color="#dfeae1"
          >
            Get Schedule 1 copy in minutes
          </Typography>
        </Box>
      </Box>

      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How long does it take to file Form 2290 using the app?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography>
                      Most truckers complete their{' '}
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 2290 filing
                      </Link>{' '}
                      in under 5 minutes. Simply enter your business details,
                      tax period, VIN, taxable gross weight. The app calculates
                      everything automatically and submits directly to the IRS.
                      No paperwork, no waiting - just fast, accurate filing from
                      your phone.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Is the TaxZerone app approved by the IRS for e-filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text">
                    <span style={{ fontWeight: 600 }}> Yes!</span> TaxZerone is
                    a fully authorized IRS e-file provider. Your{' '}
                    <Link
                      href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      2290 form
                    </Link>{' '}
                    is filed directly with the IRS electronically. You&apos;ll
                    receive your stamped Schedule 1 receipt immediately after
                    successful filing, which is required for vehicle
                    registration and DOT compliance.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Is the app available for both Android and iOS?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text">
                    <span style={{ fontWeight: 600 }}> Yes,</span> the TaxZerone
                    2290 Mobile App is available on both the{' '}
                    <Link
                      href="https://play.google.com/store/apps/details?id=com.taxzerone.excisetaxes"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      Google Play Store
                    </Link>{' '}
                    for Android devices and the{' '}
                    <Link
                      href="https://apps.apple.com/us/app/e-file-form-2290-pay-hvut/id6450998674"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      Apple App Store
                    </Link>{' '}
                    for iPhone and iPad users. Download it today to start
                    e-filing on the go.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What is the cost of e-filing Form 2290 through the app?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text">
                    <Link
                      href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      E-filing Form 2290
                    </Link>{' '}
                    through TaxZerone costs{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      $19.99 per return.
                    </span>{' '}
                    This service includes the electronic submission of your
                    Heavy Highway Vehicle Use Tax form directly to the IRS. The
                    service includes all step-by-step assistance with support,
                    automatic calculations, error checking, and instant
                    notification once your return is processed and accepted.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Can I get help if I have questions while using the app?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography itemProp="text">
                    <span style={{ fontWeight: 600 }}> Yes,</span>
                    TaxZerone provides{' '}
                    <Link href="/contact-us/" sx={{ color: '#0202ff' }}>
                      customer support
                    </Link>{' '}
                    while you use the app. You can get help via live chat,
                    email, and phone during business hours. The app also
                    includes built-in help guides for assistance,{' '}
                    <Link href="/faqs/form-2290/" sx={{ color: '#0202ff' }}>
                      FAQs
                    </Link>
                    , and a{' '}
                    <Link
                      href="/resources/excise-tax/filing-form-2290-through-the-mobile-app/"
                      sx={{ color: '#0202ff' }}
                    >
                      step-by-step instruction
                    </Link>{' '}
                    guide to help you file your 2290.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-2290/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default MobileAppForm2290;
